import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[popupIcon]',
})
export class FordjupningKartaIconDirective {
  constructor() {}
}
